module.exports = Symbol.iterator;